import styled from "styled-components";
import { Box, Small, Tag, Flex } from "orcs-design-system";

const OptionalLabel = styled(Small)`
  display: block;
`;

type SelectableOption = {
  label: string;
  optionalLabel?: string | null;
};

const selectOption = ({ label, optionalLabel }: SelectableOption) => {
  return (
    <Box>
      <span>{label}</span>
      {!!optionalLabel && optionalLabel !== label && (
        <OptionalLabel my="0" fontSize={0}>
          <strong>In:</strong> {optionalLabel}
        </OptionalLabel>
      )}
    </Box>
  );
};

const tagOption = (
  option: SelectableOption,
  { context }: { context?: string }
) => {
  if (context === "menu") {
    return (
      <Flex width="fit-content">
        <Tag tagType={option.optionalLabel ?? undefined} small>
          {option.label}
        </Tag>
      </Flex>
    );
  }
  return (
    <Flex width="fit-content">
      <Tag
        variant="selected"
        tagType={option.optionalLabel ?? undefined}
        small
        ariaLabel={option.label}
      >
        {option.label}
      </Tag>
    </Flex>
  );
};

const optionLabels = {
  selectOption,
  tagOption,
};

export default optionLabels;
